import React, { Component } from 'react';
import Input from '@material-ui/core/Input';
import './ManageExpiration/css/ManageExpiration.css'
import { DialogMessage } from './Widgets/DialogMessage';
import { Loader } from './Widgets/Loader';

export default class ManageExpiration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            locations: [],
            selectedLocation: null,
            usesBins: false,
            upc: "",
            expirationDate: "",
            qty: "",
            binNumber: "",
            showDialog: false,
            isErrorMessage: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: true
        };
        this.focusOnNextInput = this.focusOnNextInput.bind(this);
        this.refreshState = this.refreshState.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.getLocations = this.getLocations.bind(this);
        this.startLoading = this.startLoading.bind(this);
        this.stopLoading = this.stopLoading.bind(this);
        this.updateUPC = this.updateUPC.bind(this);
        this.updateExpirationDate = this.updateExpirationDate.bind(this);
        this.updateQty = this.updateQty.bind(this);
        this.updateLocation = this.updateLocation.bind(this);
        this.updateBin = this.updateBin.bind(this);
        this.submitExpiration = this.submitExpiration.bind(this);
        this.submitExpirationCallback = this.submitExpirationCallback.bind(this);
        this.displayError = this.displayError.bind(this);
        
        this.getLocations();
    }

    componentDidMount() {
        
        //when enter is pressed on the tote input, move to the slot input
        document.addEventListener("keyup", function (event) {
            if (event.keyCode === 13) {
                var upcInput = document.getElementById('upc-input');
                var expirationDateInput = document.getElementById('expiration-date-input');
                var qtyInput = document.getElementById('qty-input');
                var binInput = document.getElementById('bin-input');
                var submitButton = document.getElementById('submit-expiration');
                if (!upcInput.value) {
                    upcInput.focus();
                }
                else if (!expirationDateInput.value) {
                    expirationDateInput.focus();
                }
                else if (!qtyInput.value) {
                    qtyInput.focus();
                }
                else if (binInput && !binInput.value) {
                    binInput.focus();
                }
                else {
                   submitButton.focus();
                }
            }
        });
    }

    componentWillUnmount() {
        var upcInput = document.getElementById('upc-input');
        document.removeEventListener("keyup", function (event) {
            if (event.keyCode === 13) {
                if (upcInput.value) {
                    upcInput.blur();
                }
            }
        });
    }

    focusOnNextInput() {
        var upcInput = document.getElementById('upc-input');
        var expirationDateInput = document.getElementById('expiration-date-input');
        var qtyInput = document.getElementById('qty-input');
        var binInput = document.getElementById('bin-input');
        var submitButton = document.getElementById('submit-expiration');
        if (!upcInput.value) {
            upcInput.focus();
        }
        else if (!expirationDateInput.value) {
            expirationDateInput.focus();
        }
        else if (!qtyInput.value) {
            qtyInput.focus();
        }
        else if (binInput && !binInput.value) {
            binInput.focus();
        } else {
            submitButton.focus();
        }
    }


    refreshState() {
        this.setState({
            upc: "",
            expirationDate: "",
            qty: "",
            binNumber: "",
            showDialog: false,
            isErrorMessage: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: false
        });
        
        setTimeout(this.focusOnNextInput, 1)
    }

    closeDialog() {
        this.setState({
            showDialog: false,
            dialogFullScreen: false,
            dialogContent: "",
            dialogTitle: "",
            isErrorMessage: false
        });
    }

    async getLocations() {
        await this.props.makeRESTCall(
            'byumanageexpiration',
            'get',
            null,
            (getLocationsInfo) => {
                if (getLocationsInfo.success) {
                    console.log("INFO", getLocationsInfo);
                    this.setState({
                        locations: getLocationsInfo.locations
                    })
                } else {
                    this.stopLoading();
                    this.displayError("There was an error loading location info, Please contact I.T.", getLocationsInfo.message);
                }
            },
            (title, error) => {
                alert(error)
            },
            () => {
                this.stopLoading();
            }
        );
    }


    updateUPC(inputValue) {
        this.setState({
            upc: inputValue
        });
    }

    updateExpirationDate(inputValue) {
        this.setState({
            expirationDate: inputValue
        });
    }

    updateQty(inputValue) {
        this.setState({
            qty: inputValue
        });
    }

    updateLocation = (event) => {
        const selectedLocation = event.target.value;
        const locations = this.state.locations;
        let usesBins = false;
        if (selectedLocation) {
            for (var i in locations) {
                let location = locations[i];
                if (location.locationId == selectedLocation) {
                    usesBins = location.usesBins;
                    break;
                }
            }
        }
        this.setState({
            selectedLocation: event.target.value,
            usesBins: usesBins
        });
        this.focusOnNextInput();
    }

    updateBin(inputValue) {
        this.setState({
            binNumber: inputValue
        })
    }

    submitExpiration() {
        this.setState({
            loading: true
        });
        setTimeout(() => { this.submitExpirationCallback() }, 1);
    }

    async submitExpirationCallback() {
        let dates = this.state.expirationDate.split("-");
        const yearIndex = 0;
        const monthIndex = 1;
        const dayIndex = 2;
        const postData = {
            upc: this.state.upc,
            expirationDate: dates[monthIndex] + "/" + dates[dayIndex] + "/" + dates[yearIndex],
            qty: this.state.qty,
            location: this.state.selectedLocation,
            binNumber: this.state.binNumber,
            usesBins: this.state.usesBins
        }
        await this.props.makeRESTCall(
            'byumanageexpiration',
            'post',
            postData,
            (response) => {
                console.log(response);
                if (response.success) {
                    alert("Sucessfully Submitted!");
                    this.refreshState();
                }
                else {
                    this.displayError("Error Setting Expiration", response.message);
                }
            },
            (title, error) => {
                console.error('Error:', error);
                var errorMessage;
                if (error.message == "Failed to fetch") {
                    errorMessage = "There was an Network error. Check your internet connection and try again";
                } else {
                    errorMessage = error;
                }
                this.setState({
                    dialogContent: errorMessage,
                    dialogTitle: "Unknown Error",
                    showDialog: true,
                    isErrorMessage: true
                });
            },
            () => {
                this.setState({
                    loading: false
                });
            }
        );
    }


    startLoading() {
        this.setState({
            loading: true
        });
    }

    stopLoading() {
        this.setState({
            loading: false
        });
}

displayError(title, message) {
    this.setState({
        dialogContent: message,
        dialogTitle: title,
        showDialog: true,
        isErrorMessage: true,
        actionDialog: false
    });
}


    render() {
        console.log(this.state);
        const readyToSubmit = this.state.selectedLocation && this.state.upc && this.state.expirationDate && this.state.qty;
        return (
            <div>
                <DialogMessage
                    closeDialog={this.closeDialog}
                    showDialog={this.state.showDialog}
                    dialogTitle={this.state.dialogTitle}
                    dialogContent={this.state.dialogContent}
                    isErrorMessage={this.state.isErrorMessage}
                    dialogFullScreen={this.state.dialogFullScreen}
                />
                {
                    this.state.loading && <Loader />
                }
                <h1 className='assign-so-title'>Manage Expiration</h1>
                <br />
                <div className="location-div">
                    <select className="locationSelect" value={this.state.location?.locationId} onChange={this.updateLocation} onBlur={() => {this.focusOnNextInput()}}>
                        <option key={-1} value="" defaultValue>-Select Location-</option>
                        {
                            this.state.locations.map(function (location, idx) {
                                return (<option key={idx} value={location.locationId}>{location.locationName}</option>)
                            })}
                    </select>
                </div>
                <br />
                <div>
                    <h1 className='assign-so-subtitle'>Scan UPC</h1>
                    <input autoFocus onChange={(event) => this.updateUPC(event.target.value)} value={this.state.upc} id='upc-input' className='inventory-management-input'></input>
                </div>
                <h1 className='assign-so-subtitle'>Expiration Date</h1>
                <input type='date' onChange={(event) => this.updateExpirationDate(event.target.value)} onBlur={() => { this.focusOnNextInput() }} value={this.state.expirationDate} id='expiration-date-input' className='inventory-management-input'></input>
                <h1 className='assign-so-subtitle'>Qty</h1>
                <input type='number' onChange={(event) => this.updateQty(event.target.value)} value={this.state.qty} id='qty-input' className='inventory-management-input'></input>
                {
                    this.state.usesBins
                    &&
                    <div>
                        <h1 className='assign-so-subtitle'>Bin Number</h1>
                        <input onChange={(event) => this.updateBin(event.target.value)} value={this.state.binNumber} id='bin-input' className='inventory-management-input'></input>
                    </div>
                }
                {
                    readyToSubmit
                    &&
                    <button onClick={(event) => this.submitExpiration()} id='submit-expiration' className='assign-so-submit'>Submit</button>
                }
            </div>
        );
    }
}
